import React, { useCallback, useEffect, useContext } from 'react';
import styled from 'styled-components';
import * as styles from './styles';
import { useTranslation } from '@sunbit-dev/translations';
import { SessionExpiredContentProp } from './models';
import { ButtonWithImage } from '@sunbit-dev/web-ui-lib';
import brokenLinkIcon from '~/assets/broken-link.svg';
import refreshIcon from '~/assets/refresh.svg';
import { useTrack } from '~/hooks/track';
import { EventsNames } from '~/enums/Events';
import { PagesTestIds } from '~/enums/TestIds';
import { TrackCategory } from '@sunbit-dev/purchase-common/src/services/networkService/models';
import { ActivityContext } from '~/context/activityContext/ActivityContext';

export const SessionExpiredContent = styled(({ className }: SessionExpiredContentProp) => {
  const { t } = useTranslation('message_page', { keyPrefix: 'session_expired_by_ui' });
  const { track } = useTrack();
  const { idleTimer } = useContext(ActivityContext);

  useEffect(() => {
    if (!idleTimer.isIdle()) {
      idleTimer.pause();
    }
  }, [idleTimer]);

  useEffect(() => {
    track({ eventName: EventsNames.sessionExpiredByUI, type: TrackCategory.View });
  }, []);

  const onButtonClick = useCallback(() => {
    track({ eventName: EventsNames.tryAgainAfterSessionExpiredByUI });
    window.location.reload();
  }, [track]);

  return (
    <div className={className} data-testid={PagesTestIds.SessionInactivityMessagePage}>
      <img className="broken-link-icon" src={brokenLinkIcon} alt={t('icon_label')} />
      <div className="text title">{t('title')}</div>
      <div className="text subtitle">{t('subtitle')}</div>
      <ButtonWithImage buttonTheme="blue" className="page-button" onClick={onButtonClick}>
        <img src={refreshIcon} />
        <span className="button-label">{t('button_label')}</span>
      </ButtonWithImage>
    </div>
  );
})`
  ${styles.SessionExpiredContent}
`;
